window.ttx = window.ttx || {};
ttx.meta = {};

ttx.meta.getMeta = function (pop) {
    ttx.log.success('获取元数据');
    if (!pop) return this.meta || null;
    return pop.split('.').reduce((obj, key) => {
        return obj && obj[key] !== undefined ? obj[key] : undefined;
    }, this.meta)
}

ttx.meta.setMeta = function (meta, callback) {
    ttx.log.success('设置元数据');
    this.meta = meta
    if (typeof callback === 'function') callback(this.meta)
}
